<template>
  <v-container class="grey lighten-5">

    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">マイ機器情報にアクセスできません</span>
      </div>
      <p class="caption">
        マイ機器情報にアクセスできません。<br>
        <br>
        すでに削除されているマイ機器情報を開こうとしているか、他の事業所のマイ機器情報にアクセスしています。<br>
        もう一度マイ機器一覧からアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: 'mymachinelist' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>マイ機器一覧に戻る
    </v-card>

    <div v-if="!isErrorParam" class="my-3" >
      <v-btn icon @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
<!--
      <span class="display-1 px-3" id="title">{{AnalizeTypeCategory}}</span>
-->
      <span class="display-1 px-3" v-if ="isCreate" id="title">マイ機器 機体情報登録</span>
      <span v-else-if="isDetailInput" class="display-1 px-3" id="title">マイ機器 機体情報更新</span>
      <span v-else class="display-1" id="title">マイ機器 機体情報参照</span>

      <v-row class="ml-5 mt-3" dense>
        <v-col cols=12 dense v-if="!isDetailInput">      
          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="showUpdateUsageTime"
            >
            <v-icon class="mr-2" small>mdi-clock-outline</v-icon>使用時間を更新
          </v-btn>

          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="showOverhaulUpdate"
            >
            <v-icon class="mr-2" small>mdi-wrench-clock</v-icon>オーバーホール歴を登録
          </v-btn>

          <v-tooltip bottom color="grey darken-2" activator="#qr_btn" v-if ="!isCreate" >
            <span>クリックすると、機器専用のQRコード確認画面へ遷移します</span>
          </v-tooltip>
          <v-btn v-if ="!isCreate"
            rounded
            color="amber"
            class="mx-2 mb-2 caption"
            small
            :to="{ path: 'mymachineqrcode/', query: { id: this.machineid,  name: this.Name, type: this.Type, machineid: this.CustomerMachineID, PurchasedDate: this.PurchasedDate}}"
          >
            <v-icon class="mr-2" small>mdi-qrcode</v-icon>マイ機器QRコードを確認
          </v-btn>

          <template v-if="isDeveloper">
            <v-tooltip bottom color="grey darken-2" activator="#copy_btn" v-if ="!isCreate" >
              <span>表示中のマイ機器（機体）情報をコピーして新しいマイ機器（機体）情報を登録します</span>
            </v-tooltip>
            <v-btn v-if ="!isCreate" rounded color="blue"
              class="mx-2 mb-2 caption"
              small
              id="copy_btn"
              @click="copyMachine()"
              >
              <v-icon class="mr-2" small>mdi-content-copy</v-icon>コピーして新規作成
            </v-btn>
          </template>
        </v-col>
        <v-col cols=12 dense v-if="!isCreate && isDetailInput">
          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="closeDetailInput()"
          >
            <v-icon class="mr-2" small>mdi-close</v-icon>編集をやめる
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-card v-if="!isDetailInput" class="py-1">
      <v-card-text>
          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              マイ機器（機体）情報
            </v-card-title>
            <v-card-text>
              <v-row dense class="pt-2 pb-0 pl-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2 ">
                    項目名
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    項目名（補足）
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    設定内容
                  </div>
                </v-col>
              </v-row>

              <v-row dense class="pa-2 pt-0">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Name}}
                    <template v-if="!Name">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{CustomerMachineID}}
                    <template v-if="!CustomerMachineID">-</template>
                  </div>
                </v-col>
-->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MakerText}}
                    <template v-if="!MakerText">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('型式_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{ModelNumber}}
                    <template v-if="!ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('機器導入日_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{PurchasedDate}}
                    <template v-if="!PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TotalOperatingTime}}
                    <template v-if="!TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('修理日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OverhaulDate}}
                    <template v-if="!OverhaulDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SinceOverhaulTime}}
                    <template v-if="!SinceOverhaulTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="caption grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MachineMemo}}
                    <template v-if="!MachineMemo">-</template>
                  </div>
                </v-col>

              </v-row>

            </v-card-text>
            <v-card-actions>
            <v-row dense>
              <v-col cols=12>
                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showUpdateUsageTime"
                  >
                  <v-icon class="mr-2" small>mdi-clock-outline</v-icon>使用時間を更新
                </v-btn>

                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showOverhaulUpdate"
                  >
                  <v-icon class="mr-2" small>mdi-wrench-clock</v-icon>オーバーホール歴を登録
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showDetailInput()"
                  >
                  <v-icon class="mr-2" small>mdi-application-edit-outline</v-icon>その他の登録情報を更新
                </v-btn>
              </v-col>
            </v-row>
            </v-card-actions>
          </v-card>

          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              関連づいている装備品一覧
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols=12>
                  <v-data-table
                    :headers="mountedMachinesHeader"
                    :items="mountedMachines"
                    no-data-text="関連付けされている装備品はありません"                    
                    hide-default-footer
                    @click:row="selectMachine"
                  >
                    <template v-slot:[`item.MakerText`]="{ item }">
                      {{item.MakerText}} {{item.ModelNumber}}
                    </template>

          <template v-slot:[`item.id`]="{ item }">
            <v-tooltip left color="grey darken-2">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.isAccept == '1'"
                  v-on="on"
                  fab
                  x-small
                  elevation="1"
                  color="amber"
                  :to="{ path: 'sampling/', query: { id: item.id }}"
                  class="mx-2
                  caption"
                  id="sample_btn">
                  <v-icon small>mdi-cup-water</v-icon>
                </v-btn>
              </template>
              <span>クリックすると、分析サンプルの採取登録画面が開きます</span>
            </v-tooltip>

            <v-tooltip left color="grey darken-2">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.isAccept == '0'"
                  v-on="on"
                  readonly
                  fab
                  x-small
                  elevation="1"
                  color="gray"
                  class="mx-2
                  caption"
                  id="sample_btn">
                  <v-icon v-on="on" small>mdi-cup-water</v-icon>
                </v-btn>
              </template>
              <span>危険物が含まれるためマイ機器（オイル）のため個別にご相談ください</span>
            </v-tooltip>
          </template>


                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                rounded
                color="amber"
                class="mx-2 mb-2 caption"
                small
                @click="showMountMachine()"
                >
                <v-icon class="mr-2" small>mdi-link-variant </v-icon>装備品を関連付ける
              </v-btn>
              <v-btn
                rounded
                color="amber"
                class="mx-2 mb-2 caption"
                small
                @click="gotoCreateMachine()"
                >
                <v-icon class="mr-2" small>mdi-engine</v-icon>新しい装備品を登録する
              </v-btn>
            </v-card-actions>
          </v-card>

      </v-card-text>


    </v-card>

  <v-form v-if="!isErrorParam && isDetailInput" ref="mymachine_form">
  <v-stepper
    v-model="e6"
    vertical
    editable
  >
    <v-stepper-step :complete="e6 > 1" step="1" editable color="teal darken-1">
      マイ機器情報
    </v-stepper-step>
    <v-stepper-content step="1" >
      <v-card class="py-2">
          <v-row dense v-if ="isCreate">
            <v-col cols="12" lg="12" md='12' sm='12' xs="12">
              <v-card flat outlined class="pa-3">
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                  <span class="primary--text">機体の登録について</span>
                </div>
                <p class="caption">
                  機体情報を登録します。<br>
                  登録した機体に、分析・診断サービスの対象となるオイルを使用している装備品（エンジンや変速機など）を紐づけて登録できます。<br>
                  <br>
                  <v-icon class="mr-1" color="grey darken-4">mdi-certificate-outline</v-icon>がついている項目は報告書に記載される項目です。<br>
                  報告書への記載をご希望の場合は入力をお願いします。
                </p>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="10" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="Name"
                    :label="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('マイ機器名')[AnalizeTypeCategory+'counter']"
                    @input="$v.Name.$touch()"
                    :error-messages="NameErrors"
                    :messages="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>{{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
<!--
            <v-col cols="10" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="CustomerMachineID"
                    :label="getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']"
                    counter=12
                    @input="$v.CustomerMachineID.$touch()"
                    :error-messages="CustomerMachineIDErrors"
                    :messages="getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>{{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
-->

          </v-row>

          <v-row dense>
<!--
            <v-col cols="10" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="Equipment"
                    :label="getItemName('機械名_機体')[AnalizeTypeCategory+'label']"
                    dense
                    counter=50
                    @input="$v.Equipment.$touch()"
                    :error-messages="EquipmentErrors"
                    :messages="getItemName('機械名_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('機械名_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>機械の種類を入力してください</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
-->
<!--
            <v-col cols="10" md="5" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="CustomerName"
                    :label="getItemName('顧客名')[AnalizeTypeCategory+'label']"
                    counter=20
                    @input="$v.CustomerName.$touch()"
                    :error-messages="CustomerNameErrors"
                    :messages="getItemName('顧客名')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('顧客名')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>機器の顧客名（所有者）が異なる場合は入力して下さい。</span>
              </v-tooltip>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
-->
          </v-row>
<!--
          <v-row dense>
            <v-col cols="10" md="5" class="align-end" dense> 
              <v-select
                v-model="MachineCategory"
                label="機体の種類"
                dense
                :items="MachineCategoryList"
                item-value="Value"
                item-text="Text"
               >
                <template v-slot:prepend-inner>
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
               </v-select>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

            <v-col cols="10" md="5" class="align-end" dense> 
              <v-select
                v-model="MachineType"
                label="機体の詳細"
                dense
                :items="MachineTypeList"
                item-value="Value"
                item-text="Text"
               >
                <template v-slot:prepend-inner>
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
               </v-select>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
          </v-row>
-->

          <v-row dense>
            <v-col cols="10" md="5" class="align-end" dense> 
              <v-text-field
                v-model="MakerID"
                :label="getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'label']"
                counter=30
                @input="$v.MakerID.$touch()"
                :error-messages="MakerIDErrors"
                :messages="getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
              <!-- <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                     -->
            </v-col>
            <v-col cols="10" md="5" class="align-end" dense> 
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="ModelNumber"
                    :label="getItemName('型式_機体')[AnalizeTypeCategory+'label']"
                    counter=15
                    @input="$v.ModelNumber.$touch()"
                    :error-messages="ModelNumberErrors"
                    :messages="getItemName('型式_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('型式_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>{{getItemName('型式_機体')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row dense>
<!--
            <v-col cols="4" md="3" class="align-end" dense> 
-->
            <v-col cols="12" xl="2" lg="2" md='3' sm='3' xs="12" dense>
              <v-menu
                v-model="purchasedDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="PurchasedDate"
                    :label="getItemName('機器導入日_機体')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.PurchasedDate.$touch()"
                    :error-messages="PurchasedDateErrors"
                    :messages="getItemName('機器導入日_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('機器導入日_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="PurchasedDate"
                  @input="purchasedDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="7" xl="2" lg="2" md='3' sm='3' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="TotalOperatingTime"
                    :label="getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']"
                    @input="$v.TotalOperatingTime.$touch()"
                    :error-messages="TotalOperatingTimeErrors"
                    :messages="getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>{{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
<!--
            <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
              <v-select v-model="TotalOperatingTimeUnit" label="単位" dense :items="useUnits" item-value="Value" item-text="Text"
                clearable
                @change="changeTotalOperatingTimeUnit()"
               ></v-select>
            </v-col>
            <v-col cols="1" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
-->

          </v-row>            
          <v-row dense>          

            <v-col cols="12" xl="2" lg="2" md='3' sm='3' xs="12" dense>
              <v-menu
                v-model="overhaulDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="OverhaulDate"
                    :label="getItemName('修理日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.OverhaulDate.$touch()"
                    :error-messages="OverhaulDateErrors"
                    :messages="getItemName('修理日')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('修理日')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="OverhaulDate"
                  @input="overhaulDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="7" xl="2" lg="2" md='3' sm='3' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="SinceOverhaulTime"
                    :label="getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']"
                    @input="$v.SinceOverhaulTime.$touch()"
                    :error-messages="SinceOverhaulTimeErrors"

                    :messages="getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>{{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
<!--
              <v-select
                v-model="SinceOverhaulTimeUnit"
                label="単位"
                dense
                :items="useUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeSinceOverhaulTimeUnit()"
               ></v-select>
-->
            </v-col>
            <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
            </v-col>

          </v-row>

          <v-row dense>
            <v-col cols="12" md="12" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-textarea
                    v-model="MachineMemo"
                    :label="getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']"
                    v-on="on"
                    filled
                    counter=256
                    @input="$v.MachineMemo.$touch()"
                    :error-messages="MachineMemoErrors"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('マイ機器メモ')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-textarea>
                </template>
                <span>{{getItemName('マイ機器メモ')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

          </v-row>
<!--
          <v-btn color="primary" @click="changeStepper(2)" outlined>次へ</v-btn>
-->
          <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>

      </v-card>
    </v-stepper-content>

<!--
    <v-stepper-step :complete="e6 > 2" step="2" @click="changeStepper(2)" editable color="teal darken-1">
      搭載している装備品の選択
    </v-stepper-step>
    <v-stepper-content step="2" >
      <v-card class="py-2">

        <v-row dense>
          <v-col cols="12">
              <v-card flat outlined class="pa-3">
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                  <span class="primary--text">装備品の選択について</span>
                </div>
                <p class="caption">
                  登録する機体に装備品を紐づけます。<br>
                  機体に装備品を紐づけることで、使用時間などを一括更新できるようになります。<br>
                  機体と装備品の紐づけは、後で追加／変更することもできます。<br>
                </p>
              </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <div class="px-3">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="マイ機器を検索"
              filled
            ></v-text-field>
            </div>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" dense>
            <v-data-table
              :headers="mountedMachinesHeader"
              :items="mountedMachines"
              v-model="selectedMachines"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              :search="search"
              :sort-by="['Name']"
              :sort-desc="[false]"
              :loading="loading"
              show-select
              class="elevation-1"
              loading-text="読込中"
              no-data-text="データがありません。"                    
              no-results-text="検索条件に該当するデータがありません。"                  
              hide-default-footer
              @page-count="pageCount = $event"
              id="row-pointer"
              @item-selected="selectMachine"
              @toggle-select-all="selectAllMachines"
            >
            </v-data-table>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="10" md='10' sm='12'>
            <v-pagination
              v-model="page"
              :total-visible="totalVisible"
              :length="pageCount"
              color="amber black--text"
              light 
              circle
            >
            </v-pagination>
          </v-col>

          <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
            <v-select
              :value="itemsPerPage"
              :items = "itemsPerPageList"
              label="1ページの行数"
              @input="itemsPerPage = $event"
            ></v-select>
          </v-col>
        </v-row>
      </v-card>
    </v-stepper-content>
-->

    <div class="ma-3">
      <v-row>
        <v-col cols="9">
          <v-tooltip right color="grey" v-if ="isCreate" >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                rounded
                color="amber"
                @click="validation(3)"
                class="mx-2"
              >
                  <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>マイ機器を登録
              </v-btn>
            </template>
            <span>入力した内容で新しいマイ機器を登録します。</span>
          </v-tooltip>

          <v-tooltip top color="grey" v-else  >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                rounded
                color="amber"
                @click="validation(3)"
                data-putMachine
                class="mx-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>マイ機器情報を更新
              </v-btn>
            </template>
            <span>入力した内容で新しいマイ機器の情報を更新します。</span>
          </v-tooltip>
        </v-col>

        <v-col cols="3" class="text-lg-right">
          <v-tooltip top color="grey" v-if ="!isCreate"  >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" slot="activator" rounded color="red white--text" @click="showDeleteMachine()" dark data-delMachine>
              <v-icon class="mr-2">mdi-delete-circle</v-icon>
              このマイ機器を削除
              </v-btn>
            </template>
            <span>このマイ機器削除を削除します</span>
          </v-tooltip>
        </v-col>
      
      </v-row>

    </div>

</v-stepper>
    </v-form>

    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="80%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          {{ isCreate ?  "登録" : "更新" }}内容をご確認ください
          </v-card-title>
        <v-card-text> 下記の登録内容をご確認のうえ、「マイ機器を{{ isCreate ?  "登録" : "更新" }}」ボタンをクリックしてください</v-card-text>

          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              登録するマイ機器（機体）情報
            </v-card-title>
            <v-card-text>
              <v-row dense class="pa-2">

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Name}}
                    <template v-if="!Name">-</template>
                  </div>
                </v-col>

<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{CustomerMachineID}}
                  </div>
                </v-col>
-->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MakerID}}
                    <template v-if="!MakerID">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{ModelNumber}}
                    <template v-if="!ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{PurchasedDate}}
                    <template v-if="!PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TotalOperatingTime}}
                    <template v-if="!TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理日')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OverhaulDate}}
                    <template v-if="!OverhaulDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SinceOverhaulTime}}
                    <template v-if="!SinceOverhaulTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MachineMemo}}
                    <template v-if="!MachineMemo">-</template>
                  </div>
                </v-col>

              </v-row>

            </v-card-text>
          </v-card>




        <v-card-actions>
          <v-spacer></v-spacer>
        <v-tooltip top color="grey darken-2">
          <template v-slot:activator="{ on }">
          <v-btn
            color="grey darken-4"
            v-on="on"
            outlined
            rounded
            elevation="2"
            @click="isConfirmed = false"
          >
            キャンセル
          </v-btn>
          </template>
          <span>マイ機器情報を修正します</span>
        </v-tooltip>

        <v-tooltip top color="grey" v-if ="isCreate" >
          <template v-slot:activator="{ on }">
          <v-btn 
            rounded 
            v-on="on"
            color="amber darken-1" 
            :disabled="processing"
            @click="createMachine()" 
            data-createApplication 
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              マイ機器を登録
          </v-btn> 
          </template>
          <span>新しいマイ機器情報を登録します</span>
        </v-tooltip>

        <v-tooltip top color="grey" v-else >
          <template v-slot:activator="{ on }">
          <v-btn 
            v-on="on"
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            @click="createMachine()" 
            data-updateApplication 
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              マイ機器を更新
          </v-btn> 
          </template>
          <span>マイ機器情報を更新します</span>
        </v-tooltip>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isUsageTimeUpdate"
      persistent
      width="auto"
      max-width="70%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          使用時間を更新する
        </v-card-title>
        <v-card-subtitle class="pt-2 pb-3">
          この機器の使用時間を更新します。<br>
          装備品が搭載されている場合、すべての装備品の使用時間を更新することもできます。<br>
          <template v-if="!OverhaulDate"> 
          {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}は{{getItemName('修理日')[AnalizeTypeCategory+'label']}}が設定されている場合のみ更新できます。<br>
          </template>
          <br>
        </v-card-subtitle>
        <v-card-text>
          <v-row dense class="mb-0">
            <v-col cols="12" dense class="pa-0">
              <v-checkbox
                v-model="syncUsageTime"
                label="この機器のすべての使用時間に同じ時間を加算する"
                class="caption my-0 py-0"
                dense
                @change="changeSyncUsageTime"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
              <v-text-field
                :disabled="!syncUsageTime"
                v-model="usageTime"
                label="加算する使用時間／距離"
                @input="calcUsageTime()"
                :error-messages="usageTimeErrors"
                class="mb-0">
              </v-text-field>
            </v-col>
          </v-row>        

          <v-row dense>
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0 font-weight-bold">
              <div class="subtitle-2 grey darken-2 white--text font-weight-bold pl-2 ">
              使用時間項目
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='3' xs="12" dense class="pa-0 font-weight-bold d-none d-sm-block">
              <div class="subtitle-2 grey darken-2 white--text font-weight-bold pl-2 text-center">
              現在の時間／距離
              </div>
            </v-col>
            <v-col cols="12" xl="8" lg="6" md='4' sm='9' xs="12" dense class="pa-0 font-weight-bold">
              <div class="subtitle-2 grey darken-2 white--text font-weight-bold pl-2 ">
              更新する時間／距離
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" class="title">
              <div>
              {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
              </div>
              <div class="caption pl-2">
              {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='3' xs="3" class="d-none d-sm-block">
              <div v-if="TotalOperatingTime" class="title font-weight-regular pr-4 text-right">
                {{TotalOperatingTime}}
                <v-icon v-if="syncUsageTime" class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
              </div>
              <div v-else class="pl-2">
                ―
              </div>
            </v-col>
            <v-col cols="6" xl="2" lg="3" md='2' sm='3' xs="6">
              <template v-if="!syncUsageTime">
                <v-text-field
                  v-model="newTotalOperatingTime"
                  class="pl-2 font-weight-bold"
                  dense
                  @input="$v.newTotalOperatingTime.$touch()"
                  :error-messages="newTotalOperatingTimeErrors"
                >
                </v-text-field>
              </template>
              <template v-else>
                <div class="title text-right">
                {{ newTotalOperatingTime}}</div>
              </template>
            </v-col>
            <v-col cols="6" xl="1" lg="2" md='2' sm='2' xs="6">
<!--
              <v-select
                v-model="newTotalOperatingTimeUnit"
                label="単位"
                dense
                :items="useUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeNewTotalOperatingTimeUnit()"
               ></v-select>
-->
            </v-col>
          </v-row>


          <v-row v-if="OverhaulDate">
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12"  class="title">
              <div>
              {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
              </div>
              <div class="caption pl-2">
              {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'message']}}
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='3' xs="3" class="d-none d-sm-block">
              <div v-if="SinceOverhaulTime" class="title font-weight-regular pr-4 text-right">
                {{SinceOverhaulTime}}
                <v-icon v-if="syncUsageTime" class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
              </div>
              <div v-else class="pl-2">
                ―
              </div>
            </v-col>
            <v-col cols="6" xl="2" lg="3" md='2' sm='3' xs="6">
              <template v-if="!syncUsageTime">
                <v-text-field
                  v-model="newSinceOverhaulTime"
                  class="pl-2 font-weight-bold"
                  dense
                  @input="$v.newSinceOverhaulTime.$touch()"
                  :error-messages="newSinceOverhaulTimeErrors"
                >
                </v-text-field>
              </template>
              <template v-else>
                <div class="title text-right">
                {{ newSinceOverhaulTime}}</div>
              </template>            </v-col>
            <v-col cols="6" xl="1" lg="2" md='2' sm='2' xs="6">
<!--
              <v-select
                v-model="newSinceOverhaulTimeUnit"
                label="単位"
                dense
                :items="useUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeNewSinceOverhaulTimeUnit()"
               ></v-select>
-->
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols=12 dense>
              <v-checkbox
                v-model="syncMountedMachine"
                :disabled="!syncUsageTime"
                label="この機体に関連付けされているすべての装備品の使用時間を反映する"
                class="caption my-0 py-0"
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols=12>
              <v-data-table
                :headers="mountedMachinesUsageTimeHeader"
                :items="mountedMachines"
                no-data-text="搭載している装備品はありません"                    
                hide-default-footer
              >
                <template v-slot:[`item.TotalOperatingTime`]="{ item }">
                  <div>{{item.TotalOperatingTime}}</div>
                  <template v-if="syncMountedMachine && item.TotalOperatingTime">
                    <div class="font-weight-bold"><v-icon class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
                    {{ calcTime(item.TotalOperatingTime, usageTime)}}</div>
                  </template>
                </template>
                <template v-slot:[`item.SinceOverhaulTime`]="{ item }">
                  <div>{{item.SinceOverhaulTime}}</div>
                  <template v-if="syncMountedMachine && item.SinceOverhaulTime">
                    <div class="font-weight-bold"><v-icon class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
                    {{ calcTime(item.SinceOverhaulTime, usageTime)}}</div>
                  </template>
                </template>
                <template v-slot:[`item.OilUsageTime`]="{ item }">
                  <div>{{item.OilUsageTime}}</div>
                  <template v-if="syncMountedMachine && item.OilUsageTime">
                    <div class="font-weight-bold"><v-icon class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
                    {{ calcTime(item.OilUsageTime, usageTime)}}</div>
                  </template>
                </template>
                <template v-slot:[`item.FilterUsageTime`]="{ item }">
                  <div>{{item.FilterUsageTime}}</div>
                  <template v-if="syncMountedMachine && item.FilterUsageTime">
                    <div class="font-weight-bold"><v-icon class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
                    {{ calcTime(item.FilterUsageTime, usageTime)}}</div>
                  </template>
                </template>

              </v-data-table>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="closeUpdateUsageTime"
          >
            キャンセル
          </v-btn>

          <v-btn 
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            data-createApplication 
            @click="updateUsageTime()"
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              更新
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successUsageTimeUpdate"
      persistent
      width="auto"
      max-width="60%"
    >
      <v-card class="px-1 py-1">
         <v-card-text class="text-center">
          <v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon>
          <div class="title">使用時間を更新しました</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successUsageTimeUpdate = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isMountMachine"
      persistent
      width="auto"
      max-width="70%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          装備品を関連付ける
          <v-spacer></v-spacer>
          <v-icon @click="closeMountMachine" class="my-3 mx-2">mdi-close-circle </v-icon>
        </v-card-title>
        <v-card-subtitle>
          この機体に装備品を関連付けて管理します。
        </v-card-subtitle>
        <v-card-text>

          <v-stepper
            v-model="se6"
            vertical
            editable
            class="ma-0"
          >
            <v-stepper-step :complete="se6 > 1" step="1" editable color="teal darken-1" class="ma-0 pa-2">
              装備品を選択する
            </v-stepper-step>
            <v-stepper-content step="1">

              <v-row>
                <v-col cols=12>
                  <v-data-table
                    :headers="mountMachinesHeader"
                    :items="mountMachines"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    no-data-text="装備品が登録されていません"                    
                    hide-default-footer
                    :sort-by="['MountedMachineName']"
                    @click:row="selectMountMachine"
                  >

                <template v-slot:[`item.MountedMachineName`]="{ item }">
                  {{getAirCraftName(item.MountedMachineID)}}
                </template>


                  </v-data-table>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="10" md='10' sm='12'>
                  <v-pagination
                    v-model="page"
                    :total-visible="totalVisible"
                    :length="pageCount"
                    color="amber black--text"
                    light 
                    circle
                  >
                  </v-pagination>
                </v-col>
                <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
                  <v-select
                    :value="itemsPerPage"
                    :items = "itemsPerPageList"
                    label="1ページの行数"
                    @input="itemsPerPage = $event"
                  ></v-select>
                </v-col>
              </v-row>

            </v-stepper-content>

            <v-stepper-step :complete="se6 > 2" step="2" color="teal darken-1" class="ma-0 pa-2 pb-0">
              機体に関連付ける
            </v-stepper-step>
            <v-stepper-content step="2" class="ma-1 pt-0 pa-1">
                  
              <v-card flat v-if="mountMachine">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" xl="12" lg="12" md='12' sm='12' xs="12" dense>

                      <v-card flat outlined height=100%>
                        <v-card-title class="body-1 py-0 px-2 teal darken-1 white--text">
                          関連付ける装備品
                        </v-card-title>
                        <v-card-text class="pt-2">
                          <v-row dense class="pa-0">
<!--
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('マイ機器名')[AnalizeTypeCategory+'label']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="caption grey lighten-3 pl-2">
                                {{getItemName('マイ機器名')[AnalizeTypeCategory + 'message']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0">
                              <div class="body-1  font-weight-bold pl-2">
                                {{mountMachine.Name}}
                                <template v-if="!mountMachine.Name">-</template>
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0">
                            </v-col>
-->
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="caption grey lighten-3 pl-2">
                                {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory + 'message']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0">
                              <div class="body-1  font-weight-bold pl-2">
                                {{mountMachine.CustomerMachineID}}
                                <template v-if="!mountMachine.CustomerMachineID">-</template>
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0">
                            </v-col>

                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
<!--
                    <v-col cols="12" xl="3" lg="3" md='12' sm='12' xs="12" dense>
                      <v-card flat outlined class="grey lighten-4 white--text" height=100%>
                        <v-card-title class="body-1 py-0 px-2 grey">
                          現在関連づいている機体
                        </v-card-title>
                        <v-card-text class="pt-2">
                          <template  v-if="mountedMachine">
                            {{mountedMachine.Name}}<br>
                            {{mountedMachine.CustomerMachineID}}
                          </template>
                          <template v-else>
                            ありません
                          </template>
                        </v-card-text>
                      </v-card>
                    </v-col>
-->
                    <v-col cols="12" xl="12" lg="12" md='12' sm='12' xs="12" dense>
                      <v-card flat outlined height=100%>
                        <v-card-title class="body-1 py-0 px-2 teal darken-1 white--text">
                          新しく関連付ける機体
                        </v-card-title>
                        <v-card-text class="pt-2">

                          <v-row dense class="pa-0">
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0 grey darken-2 white--text">
                              <div class="subtitle-2 pl-2">
                                項目名
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0 grey darken-2 white--text">
                              <div class="subtitle-2 pl-2">
                                項目名（補足）
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0 grey darken-2 white--text">
                              <div class="subtitle-2 pl-2">
                                現在の機体
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0 grey darken-2 white--text">
                              <div class="subtitle-2 pl-2">
                                新しい機体
                              </div>
                            </v-col>
                          </v-row>

                          <v-row dense class="pa-0">
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('マイ機器名_機体')[AnalizeTypeCategory + 'message']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0">
                              <div v-if="mountedMachine" class="body-1 font-weight-bold pl-2">
                                <template v-if="!mountedMachine.Name">-</template>
                                <template v-else>{{mountedMachine.Name}}</template>
                              </div>
                              <div v-else class="body-1  font-weight-bold pl-2">
                                -
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0">
                              <div class="body-1  font-weight-bold pl-2">
                                {{Name}}
                                <template v-if="!Name">-</template>
                              </div>
                            </v-col>
<!--
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory + 'message']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0">
                              <div v-if="mountedMachine" class="body-1  font-weight-bold pl-2">
                                <template v-if="!mountedMachine.CustomerMachineID">-</template>
                                <template v-else>{{mountedMachine.CustomerMachineID}}</template>
                              </div>
                              <div v-else class="body-1  font-weight-bold pl-2">
                                -
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0">
                              <div class="body-1  font-weight-bold pl-2">
                                {{CustomerMachineID}}
                                <template v-if="!CustomerMachineID">-</template>
                              </div>
                            </v-col>
-->

                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('搭載位置')[AnalizeTypeCategory+'label']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="mb-1 pa-0 grey lighten-3">
                              <div class="subtitle-2 grey lighten-3 pl-2">
                                {{getItemName('搭載位置')[AnalizeTypeCategory + 'message']}}
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0">
                              <div v-if="mountMachine" class="body-1 font-weight-bold pl-2">
                                <template v-if="!mountMachine.MountPosition">-</template>
                                <template v-else>{{mountMachine.MountPosition}}</template>
                              </div>
                              <div v-else class="body-1  font-weight-bold pl-2">
                                -
                              </div>
                            </v-col>
                            <v-col cols="12" xl="3" lg="3" md='3' sm='12' xs="12" dense class="pa-0">
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="MountPosition"
                                counter=2
                                class="pa-0"
                                @input="$v.MountPosition.$touch()"
                                :error-messages="MountPositionErrors"
                                :messages="getItemName('搭載位置')[AnalizeTypeCategory + 'message']"
                              >
                                <template v-slot:prepend-inner v-if="getItemName('搭載位置')[AnalizeTypeCategory+'証明書']">
                                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                                </template>
                              </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('搭載位置')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>

                            </v-col>
                          </v-row>


                        </v-card-text>
                      </v-card>
                    </v-col>

                  </v-row>

                <v-row class="body-1 ma-0 pa-0">
                  <v-col cols="12" xl="12" lg="12" md='12' sm='12' xs="12" dense>
                    <div v-if="!mountedMachine">
                      {{mountMachine.Name}} をこの機体に関連づけますか？<br>
                    </div>
                    <div v-if="mountedMachine && mountedMachine.id != mountMachine.id" class="body-1">
                      現在 {{mountedMachine.Name}} に関連づいています。<br>
                      関連付けを変更しますか？
                    </div>
                    <div v-if="mountedMachine && mountedMachine.id == mountMachine.id" class="body-1">
                      すでに {{mountedMachine.Name}} に関連づいています。<br>
                      搭載位置を変更しますか？
                    </div>
                  </v-col>
                </v-row>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey darken-4"
                    outlined
                    rounded
                    elevation="2"
                    @click="closeMountMachine"
                  >
                    キャンセル
                  </v-btn>

                  <v-btn 
                    rounded 
                    color="amber darken-1" 
                    :disabled="processing"
                    data-createApplication 
                    @click="updateMountMachine()"
                    class="px-2">
                      <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                      関連付ける
                  </v-btn> 
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper>

        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successMountMachine"
      persistent
      max-width="30%"
    >
      <v-card class="px-3 py-2">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          装備品を関連付けました。
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successMountMachine = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isOverhaulUpdate"
      persistent
      width="auto"
      max-width="70%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          オーバーホール歴を登録する
        </v-card-title>
        <v-card-subtitle>
          この機器の{{getItemName('修理日')[AnalizeTypeCategory+'label']}}と{{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}を更新します。
        </v-card-subtitle>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" xl="2" lg="3" md='12' sm='12' xs="12" dense class="pa-0">
              <v-menu
                v-model="newOverhaulDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newOverhaulDate"
                    :label="getItemName('修理日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.newOverhaulDate.$touch()"
                    :error-messages="newOverhaulDateErrors"
                    :messages="getItemName('修理日')[AnalizeTypeCategory+'message']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newOverhaulDate"
                  @input="newOverhaulDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" xl="2" lg="3" md='12' sm='12' xs="12" dense class="pa-0">
              <v-text-field
                v-model="newSinceOverhaulTime"
                :label="getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']"
                @input="$v.newSinceOverhaulTime.$touch()"
                :error-messages="newSinceOverhaulTimeErrors"
                :messages="getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'message']"
              >
              </v-text-field>
            </v-col>

<!--
            <v-col cols="3" xl="2" lg="3" md='3' sm='3' xs="3" dense class="pa-0">
              <v-select
                v-model="newSinceOverhaulTimeUnit"
                label="単位"
                dense
                :items="useUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeNewSinceOverhaulTimeUnit()"
              ></v-select>
            </v-col>
-->
          </v-row>

          <v-row dense class="mt-5">
            <v-col cols="12" class="pa-0">
              <span class="caption">{{getItemName('修理メモ')[AnalizeTypeCategory+'label']}}</span>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-model="OverhaulMemo"
                      filled
                      counter=256
                      v-on="on"
                    ></v-textarea>
                  </template>
                  <span>{{getItemName('修理メモ')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="closeOverhaulUpdate"
          >
            キャンセル
          </v-btn>

          <v-btn 
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            data-createApplication 
            @click="updateOverhaulDate()"
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              更新
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successOverhaulUpdate"
      persistent
      width="auto"
      max-width="60%"
    >
      <v-card class="px-1 py-1">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          オーバーホール歴を登録しました
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successOverhaulUpdate = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="successCreateMachine"
      persistent
      max-width="30%"
    >
      <v-card>
         <v-card-text class="text-center">
           <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          <div>
          新しい機体を登録しました。<br>
          <br>
          続いて機体に装備品を登録（関連付け）して下さい。<br>
          「機体情報を見る」からこの機体に装備品情報を関連付けできます。

          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
<!--
          <v-btn
            color="teal darken-1"
            rounded
            outlined
            @click="showDialog()"
            class="mb-5"
          >
            戻る
          </v-btn>
-->
          <v-btn
            color="amber darken-1"
            rounded
            @click="toUpdateMachine"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-airplane</v-icon>
              機体情報を見る
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  <!-- dialogコール -->
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <!--
  <msuc-dialog :successText="successText" :successUrl="successUrl" ref="isMSuccessed"></msuc-dialog>
  -->
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
  <deleteMachineconfirm :machineid="machineid" :Name="Name" :CustomerMachineID="CustomerMachineID" ref="deletedialog"></deleteMachineconfirm>
  <!-- <deleteMachineconfirm :Name="Name" :CustomerMachineID="CustomerMachineID" ref="deletedialog"></deleteMachineconfirm> -->

  <loading-dialog :message="loadingMessage" :progressMessages="progressMessages" ref="isLoading"></loading-dialog>

  </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { createMachine, updateMachine, deleteMachine } from "../graphql/mutations"
import { createMachineLog } from "../graphql/mutations"
import { required, maxLength, numeric,  } from 'vuelidate/lib/validators'
import validations from '../utils/validations.js'
import mixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'
import { getMachine } from '../graphql/queries'
import { fetchAllMachineByOffice } from '../utils/utils'
import { mountedMachine } from '../graphql/queries'
import deleteMachineconfirm from '../components/DeleteMachineConfirm'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successDialog.vue"
//import { helpers } from 'vuelidate/lib/validators'
import Loading from "../components/Loading.vue"

function hasTotalOperatingTimeUnit (value, vm) {
  if (vm.TotalOperatingTime) {
    if(!vm.TotalOperatingTimeUnit) {
      return false
    }
  }
  return true
}
function hasNewTotalOperatingTimeUnit (value, vm) {
  if (vm.newTotalOperatingTime) {
    if(!vm.newTotalOperatingTimeUnit) {
      return false
    }
  }
  return true
}
function hasSinceOverhaulTimeUnit (value, vm) {
  if (vm.SinceOverhaulTime) {
    if(!vm.SinceOverhaulTimeUnit) {
      return false
    }
  }
  return true
}

function hasNewSinceOverhaulTimeUnit (value, vm) {
  if (vm.newSinceOverhaulTime) {
    if(!vm.newSinceOverhaulTimeUnit) {
      return false
    }
  }
  return true
}
function dateFormat(value) {
  if(value) {
    if(!value.match(/^\d{4}-\d{1,2}-\d{1,2}$/)){
        return false;
    }else {
      var date = new Date(value);
      var m = value.split("-")[1];
      console.log(m, date.getMonth() + 1)
      if(m != date.getMonth() + 1) {
        return false
      }
      return true
    }
  }else {
    return true
  }
}
function alphaNumPlus(value) {
  if(value) {
    // JETの場合 半角英数（＋ハイフン、ドット）のみ許可
    if(!value.match(/^[0-9a-zA-Z/.\s_-]*$/)){
        return false;
    }
  }
  return true
}

/*
const byteLen = (param) =>
  helpers.withParams(
    { type: 'byteLen', value: param },
    (value) => {
      let lenB = 0
      for (let i = 0; i < value.length; i++) {
        (value[i].match(/[ -~]/)) ? lenB += 1 : lenB += 2;
      }

      if(lenB > param) {
        return false
      }
      
      return true
    }
  )
*/

/*
function float(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1,2})?$/)){
        return false;
    }
  }
  return true
}
*/
function useTime(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1})?$/)){
      if(_value.match(/^([0-9]\d*):([0-5][0-9])$/)){
        return true;
      }else {
        return false;
      }
    }
  }
  return true
}

export default {

  beforeRouteLeave (to, from, next) {
    // console.log('router',to)
    if (this.$v.$anyDirty&&!this.isPageMove) {
      let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
       next()
    }
  },

  mixins:[validations, mixin, utils],
  components:{
    deleteMachineconfirm,
    // VueQrcode,
    sucDialog: entSuccessed,
//    msucDialog: aircraftSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
    LoadingDialog: Loading,
  },
  head: {
    title: { inner: 'マイ機器'},
  },
  data: () => ({
    Name: "",
    CustomerName: "",
    CustomerMachineID: "",
    MakerID: "",
    MakerText: "",
    ModelNumber: "",
    PurchasedDate: "",
    MachineMemo: "",
    TotalOperatingTime: null,
    TotalOperatingTimeUnit: "",
    TotalOperatingTimeUnitText: "",

    OverhaulDate: "",
    SinceOverhaulTime: null,
    SinceOverhaulTimeUnit: "",
    SinceOverhaulTimeUnitText: "",

    Equipment: "",
    Type: "",
    AnalizeTypeCategory: "",

/*
    MachineCategory: "",
    MachineType: "",
    MachineCategoryList: [],

    MachineTypeList: [],
*/
    isAccept: "1",
    OfficeID: "",

    success: false,
    dialog: false,
    successCreateMachine: false,

    e6: 1,
    se6: 1,
    machineid: "",
    isCreate: true,
    isDetailInput: false,

    isUsageTimeUpdate: false,
    successUsageTimeUpdate: false,
    usageTime: 0,
    syncUsageTime: false,
    syncMountedMachine: false,
    newTotalOperatingTime: null,
    newTotalOperatingTimeUnit: "",
    newTotalOperatingTimeUnitText: "",
    newSinceOverhaulTime: null,
    newSinceOverhaulTimeUnit: "",
    newSinceOverhaulTimeUnitText: "",

    isOverhaulUpdate: false,
    successOverhaulUpdate: false,
    newOverhaulDate: "",
    newOverhaulDatePicker: false,
    OverhaulMemo: "",

    isConfirmed: false,
    overlayStepper1: true,
    isSwStandard: false,
    isPageMove: false,
    processing: false,
    successUrl: '/mymachinelist',
    successText: 'ご登録いただいた機器は、マイ機器よりご確認ください。',
    valiErrorText: '申請内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
    failureUrl: '/mymachinelist',

    purchasedDatePicker: false,
    overhaulDatePicker: false,

    isErrorParam: false,
    ErrorInfo: "",

    search: '',
    page: 1,
    pageCount: 0,
    totalVisible: 7,
    itemsPerPage: 10,
    itemsPerPageList: [ 5,10,30 ],
    loading: false,      
    mountedMachinesHeader: [
/*
      {
        text: 'マイ機器名',
        align: 'start',
        value: 'Name',
        class: "grey darken-2 white--text",
      },
*/
      {
        text: 'マイ機器ＩＤ',
        value: 'CustomerMachineID',
        class: "grey darken-2 white--text"

      },
      {
        text: '機械名',
        value: 'Equipment',
        class: "grey darken-2 white--text",
        sortable: false,

      },
      {
        text: '機械製造メーカー／型式',
        value: 'MakerText',
        class: "grey darken-2 white--text",
        sortable: false,
      },
      {
        text: '搭載位置',
        value: 'MountPosition',
        class: "grey darken-2 white--text",
        sortable: false,

      },
      {
        text: '',
        value: 'id',
        class: "grey darken-2 white--text",
        sortable: false,
      },
    ],

    mountMachinesHeader: [
      {
        text: 'マイ機器名',
        align: 'start',
        value: 'Name',
        class: "grey darken-2 white--text",
      },
      {
        text: 'マイ機器ＩＤ',
        value: 'CustomerMachineID',
        class: "grey darken-2 white--text"

      },
      {
        text: '機械名',
        value: 'Equipment',
        class: "grey darken-2 white--text"

      },
      {
        text: '機械製造メーカー／型式',
        value: 'MakerText',
        class: "grey darken-2 white--text"

      },
      {
        text: '搭載機',
        value: 'MountedMachineName',
        class: "grey darken-2 white--text"

      },
      {
        text: '搭載位置',
        value: 'MountPosition',
        class: "grey darken-2 white--text"

      },
    ],

    mountedMachinesUsageTimeHeader: [
/*      
      {
        text: 'マイ機器名',
        align: 'start',
        value: 'Name',
        class: "grey darken-2 white--text",
      },
*/
      {
        text: 'マイ機器ＩＤ',
        value: 'CustomerMachineID',
        class: "grey darken-2 white--text"

      },
      {
        text: '累計使用時間',
        value: 'TotalOperatingTime',
        class: "grey darken-2 white--text"

      },
      {
        text: 'ｵｰﾊﾞｰﾎｰﾙ後使用時間',
        value: 'SinceOverhaulTime',
        class: "grey darken-2 white--text"

      },
      {
        text: 'オイル使用時間',
        value: 'OilUsageTime',
        class: "grey darken-2 white--text"

      },
      {
        text: 'フィルター使用時間',
        value: 'FilterUsageTime',
        class: "grey darken-2 white--text"

      },
    ],
    mountedMachines: [],
    selectedMachines: [],

    isMountMachine: false,
    successMountMachine: false,
    mountMachines: [],
    mountMachine: null,
    mountedMachine: null,
    MountPosition: "",

    aircrafts: [],

    loadingMessage: "処理中です。しばらくこのままでお待ちください。",
    progressMessages: [{"status":0, "message":"機体の情報更新"}, {"status":0, "message":"装備品の情報更新"}],

  }),
  validations: {
      Name: { required, alphaNumPlus, maxLength: maxLength(15) },
      CustomerMachineID: { alphaNumPlus, maxLength: maxLength(12) },
//      Equipment: { maxLength: maxLength(50) },
//      CustomerName: { maxLength: maxLength(20) },
      MakerID: { maxLength: maxLength(30) },
      ModelNumber: { alphaNumPlus, maxLength: maxLength(15) },
      PurchasedDate: { dateFormat },
      TotalOperatingTime: { useTime, hasTotalOperatingTimeUnit },
      OverhaulDate: { dateFormat },
      SinceOverhaulTime: { useTime, hasSinceOverhaulTimeUnit },
      MachineMemo: { maxLength: maxLength(256) },

      MountPosition: { numeric, maxLength: maxLength(2) },

      usageTime: {useTime},
      newTotalOperatingTime: { useTime, hasNewTotalOperatingTimeUnit },
      newOverhaulDate: { required, dateFormat },
      newSinceOverhaulTime: { useTime, hasNewSinceOverhaulTimeUnit },
  },
  computed: {
    NameErrors () {
        return this.defaultMessage(this.$v.Name)
    },
    EquipmentErrors () {
        return this.defaultMessage(this.$v.Equipment)
    },
    CustomerNameErrors () {
        return this.defaultMessage(this.$v.CustomerName)
    },
    CustomerMachineIDErrors () {
        return this.defaultMessage(this.$v.CustomerMachineID)
    },
    MakerIDErrors () {
        return this.defaultMessage(this.$v.MakerID)
    },
    ModelNumberErrors () {
        return this.defaultMessage(this.$v.ModelNumber)
    },
    TotalOperatingTimeErrors () {
        return this.defaultMessage(this.$v.TotalOperatingTime)
    },
    SinceOverhaulTimeErrors () {
        return this.defaultMessage(this.$v.SinceOverhaulTime)
    },
    MachineMemoErrors () {
        return this.defaultMessage(this.$v.MachineMemo)
    },
    PurchasedDateErrors() {
        return this.defaultMessage(this.$v.PurchasedDate)
    },
    OverhaulDateErrors() {
        return this.defaultMessage(this.$v.OverhaulDate)
    },
    MountPositionErrors() {
      return this.defaultMessage(this.$v.MountPosition)
    },

    newTotalOperatingTimeErrors () {
      return this.defaultMessage(this.$v.newTotalOperatingTime)
    },
    newOverhaulDateErrors() {
      return this.defaultMessage(this.$v.newOverhaulDate)
    },
    newSinceOverhaulTimeErrors () {
      return this.defaultMessage(this.$v.newSinceOverhaulTime)
    },
    usageTimeErrors () {
      return this.defaultMessage(this.$v.usageTime)
    },    
    
    useUnits () {
      return this.$store.state.useUnits
    },

    isDeveloper () {
      return this.$store.state.isDeveloper
    },
  },
  methods: {
    copyMachine: async function () {
      if (this.$v.$anyDirty&&!this.isPageMove) {
        let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
        console.log("answer", answer)
        if (!answer) {
          return
        }
      }
      this.isCreate = true
      await this.getMachine()
      this.machineid = ""
    },
    showDetailInput: function () {
      this.isDetailInput = true
      this.moveToTop()
    },
    closeDetailInput: async function() {
      this.isDetailInput = false
      await this.getMachine()
      this.moveToTop()
    },
    gotoCreateMachine: async function() {
      this.$router.push("/mymachine?type=装備装置" + "&category=航空機" + "&mountmachine=" + this.machineid)
    },
    showMountMachine: async function() {
      let OfficeID = this.$store.state.operatingOffice.OfficeID
      // 分析区分がJETの装備品の一覧
      // 移行直後は「TYPE」がないTYPEなしも装備品として扱う。
      let typeFilter = {
        and: [
          {
            AnalizeType:{beginsWith: "2"}
          },
          {
            or: [
              {
                 Type:{contains: "装備装置"}
              },
              {
                Type:{attributeExists: false}
              },
            ]
          }
        ]
      }
      let machines = await fetchAllMachineByOffice(OfficeID, typeFilter)
      this.mountMachines = machines;

      // 搭載機の名称を取得
      // 性能劣化著しいのでやめ
//      for (const mountMachine of this.mountMachines) {
//        if(mountMachine.MountedMachineID) {
//          let _mountMachine = await API.graphql(graphqlOperation(getMachine,{id: mountMachine.MountedMachineID}))
//          mountMachine["MountedMachineName"] = _mountMachine.data.getMachine.CustomerMachineID
//          mountMachine["MountedMachine"] = _mountMachine
//        }
//      }

      this.aircrafts = []
      typeFilter = {
          Type:{
            contains: "機体"
          }
      }
      let _aircrafts = await fetchAllMachineByOffice(OfficeID, typeFilter)
      this.aircrafts = _aircrafts;
      console.log("aircrafts:", this.aircrafts)

      this.se6 = 1
      this.mountMachine = null
      this.MountPosition = ""
      this.isMountMachine = true
    },
    getAirCraftName: function(id) {
      if(id) {
        const aircraft = this.aircrafts.filter(item => item.id  == id)
        let name = ""
        if(aircraft[0]) {
          name = aircraft[0].CustomerMachineID
        }else {
          name = "不明な機体"
        }
        return name
      }else{
        return ""
      }
    },
    selectMountMachine: async function(data) {
      this.mountMachine = data
      this.mountedMachine = null
      let MountedMachineID = this.mountMachine.MountedMachineID
      if(MountedMachineID) {
        let machine = await API.graphql(graphqlOperation(getMachine, {id: MountedMachineID}))
        this.mountedMachine = machine.data.getMachine
        console.log("mountedMachine:", this.mountedMachine)
      }
      this.se6 = 2
    },
    closeMountMachine: async function() {
      this.isPageMove=true
      this.isMountMachine = false
    },

    updateMountMachine: async function() {
      try {
        console.log("mount Machine:", this.mountMachine)

        this.$v.MountPosition.$touch()
        if (this.$v.MountPosition.$invalid){
          console.log('updateMountMachine input error')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }

        let machine = {}
        machine["id"] = this.mountMachine.id
        machine["MountedMachineID"] = this.machineid
        machine["MountPosition"] = this.MountPosition
        await API.graphql(graphqlOperation(updateMachine, {input: machine}))

        let machineLog = {}
        machineLog.MachineID = this.mountMachine.id
        machineLog.Type = "Mount"
        machineLog.Detail = this.Name + "/" + this.MountPosition
        await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

        let mountedMachines = await API.graphql(graphqlOperation(mountedMachine, {MountedMachineID: this.machineid}))
        console.log("mountedMachines", mountedMachines)
        this.mountedMachines = mountedMachines.data.mountedMachine.items

        this.isPageMove=true

        this.isMountMachine = false
        this.successMountMachine = true
      } catch (error) {
        console.log('error: ', error)
        this.processing = false
        this.isPageMove=true
        this.$refs.isFailured.open();
      }
    },

    showOverhaulUpdate: async function() {
      this.newOverhaulDate = ""
      this.newSinceOverhaulTime = ""
      this.newSinceOverhaulTimeUnit = this.SinceOverhaulTimeUnit
      this.newSinceOverhaulTimeUnitText = this.SinceOverhaulTimeUnitText

      this.isOverhaulUpdate = true
    },
    closeOverhaulUpdate: async function() {
      this.isPageMove=true
      this.isOverhaulUpdate = false
    },
    updateOverhaulDate: async function() {
      this.$v.newOverhaulDate.$touch()
      this.$v.newSinceOverhaulTime.$touch()
      if ((this.$v.newOverhaulDate.$invalid) ||
          (this.$v.newSinceOverhaulTime.$invalid)
      ){
        console.log('updateOverhaulDate input error')
        this.$refs.isErrored.open();
        this.isErrored = true
        this.processing = false
        return 1
      }

      try {
        let machine = {}
        machine["id"] = this.machineid
        machine["OverhaulDate"] = this.newOverhaulDate
        machine["SinceOverhaulTime"] = this.newSinceOverhaulTime
        machine["SinceOverhaulTimeUnit"] = this.newSinceOverhaulTimeUnit
        machine["SinceOverhaulTimeUnitText"] = this.newSinceOverhaulTimeUnitText
          
        await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "Overhaul"
          machineLog.Detail = this.newOverhaulDate + "/" +
                              this.newSinceOverhaulTime + " " + this.newSinceOverhaulTimeUnitText
          machineLog.Description = this.OverhaulMemo
          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

        this.OverhaulDate = this.newOverhaulDate
        this.SinceOverhaulTime = this.newSinceOverhaulTime
        this.SinceOverhaulTimeUnit = this.newSinceOverhaulTimeUnit
        this.SinceOverhaulTimeUnitText = this.newSinceOverhaulTimeUnitText

        this.isOverhaulUpdate = false
        this.successOverhaulUpdate = true

        this.newOverhaulDate = ""
        this.newSinceOverhaulTime = null
        this.newSinceOverhaulTimeUnit = ""
        this.newSinceOverhaulTimeUnitText = ""

        this.isPageMove=true

      } catch (error) {
        console.log('updateOverhaulDate error: ', error)
        this.processing = false
        this.$refs.isFailured.open();
      }

    },

    showUpdateUsageTime: async function() {
      this.usageTime = 0
      this.syncUsageTime = false
      this.syncMountedMachine = false

      this.newTotalOperatingTime = this.TotalOperatingTime
      this.newTotalOperatingTimeUnit = this.TotalOperatingTimeUnit
      this.newTotalOperatingTimeUnitText = this.TotalOperatingTimeUnitText

      this.newSinceOverhaulTime = this.SinceOverhaulTime
      this.newSinceOverhaulTimeUnit = this.SinceOverhaulTimeUnit
      this.newSinceOverhaulTimeUnitText = this.SinceOverhaulTimeUnitText

      this.isUsageTimeUpdate = true
    },
    closeUpdateUsageTime: async function() {
      this.isPageMove=true
      this.isUsageTimeUpdate = false
    },

    updateUsageTime: async function() {
      console.log("updateUsageTime usageTime:", this.usageTime)
      console.log("updateUsageTime newTotalOperatingTime:", this.newTotalOperatingTime)
      console.log("updateUsageTime newTotalOperatingTimeUnit:", this.newTotalOperatingTimeUnit)
      this.$v.usageTime.$touch()
      this.$v.newTotalOperatingTime.$touch()

      if ((this.$v.usageTime.$invalid) ||
          (this.$v.newTotalOperatingTime.$invalid)
      ){
        console.log('updateUsageTime input error')
        this.$refs.isErrored.open();
        this.isErrored = true
        this.processing = false
        return 1
      }

      if(this.newSinceOverhaulTime != null) {
        console.log("updateUsageTime newSinceOverhaulTime:", this.newSinceOverhaulTime)
        this.$v.newSinceOverhaulTime.$touch()
        if (this.$v.newSinceOverhaulTime.$invalid) {
          console.log('updateUsageTime newSinceOverhaulTime input error')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }
      }

      try {
        // float型の項目は未入力の場合はnull置き換え
        if(this.newTotalOperatingTime == "") {
          this.newTotalOperatingTime = null
          this.newTotalOperatingTimeUnit = ""
          this.newTotalOperatingTimeUnitText = ""
        }

        if(this.newSinceOverhaulTime == "") {
          this.newSinceOverhaulTime = null
          this.newSinceOverhaulTimeUnit = ""
          this.newSinceOverhaulTimeUnitText = ""
        }

        this.isUsageTimeUpdate = false
        this.$refs.isLoading.start();

        let machine = {}
        machine["id"] = this.machineid
        machine["TotalOperatingTime"] = this.newTotalOperatingTime
        machine["TotalOperatingTimeUnit"] = this.newTotalOperatingTimeUnit
        machine["TotalOperatingTimeUnitText"] = this.newTotalOperatingTimeUnitText

        machine["SinceOverhaulTime"] = this.newSinceOverhaulTime
        machine["SinceOverhaulTimeUnit"] = this.newSinceOverhaulTimeUnit
        machine["SinceOverhaulTimeUnitText"] = this.newSinceOverhaulTimeUnitText

        await API.graphql(graphqlOperation(updateMachine, {input: machine}))

        let machineLog = {}
        machineLog.MachineID = this.machineid
        machineLog.Type = "UsageTime"
        machineLog.Detail = "[T.T]" + this.newTotalOperatingTime + " " + this.newTotalOperatingTimeUnitText + " " +
                            "[TSO]" + this.newSinceOverhaulTime + " " + this.newSinceOverhaulTimeUnitText

        await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

        this.progressMessages.splice( 0, 1, {"status":1, "message":"機体の情報更新完了"});

        if(this.syncMountedMachine) {
          for (const mountedMachine of this.mountedMachines) {
            let machine = {}
            let isUpdate = false
            machine["id"] = mountedMachine.id

            let machineLog = {}
            let logDetail = ""


            if(mountedMachine.TotalOperatingTime) {
              machine["TotalOperatingTime"] = this.calcTime(mountedMachine.TotalOperatingTime, this.usageTime)
              logDetail = logDetail + "[T.T]" + machine["TotalOperatingTime"] + " "
              isUpdate = true
            }
            if(mountedMachine.SinceOverhaulTime) {
              machine["SinceOverhaulTime"] = this.calcTime(mountedMachine.SinceOverhaulTime, this.usageTime)
              logDetail = logDetail + "[TSO]" + machine["SinceOverhaulTime"] + " "
              isUpdate = true
            }
            if(mountedMachine.OilUsageTime) {
              machine["OilUsageTime"] = this.calcTime(mountedMachine.OilUsageTime, this.usageTime)
              logDetail = logDetail + "[TSOD]" + machine["OilUsageTime"] + " "
              isUpdate = true
            }
            if(mountedMachine.FilterUsageTime) {
              machine["FilterUsageTime"] = this.calcTime(mountedMachine.FilterUsageTime, this.usageTime)
              logDetail = logDetail + "[TSOF]" + machine["FilterUsageTime"] + " "
              isUpdate = true
            }

            if(isUpdate) {
              await API.graphql(graphqlOperation(updateMachine, {input: machine}))

              machineLog.MachineID = machine.id
              machineLog.Type = "UsageTime2"
              machineLog.Detail = logDetail
              await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))
            }
          }

          let mountedMachines = await API.graphql(graphqlOperation(mountedMachine, {MountedMachineID: this.machineid}))
          console.log("mountedMachines", mountedMachines)
          this.mountedMachines = mountedMachines.data.mountedMachine.items
        }

        this.progressMessages.splice( 0, 1, {"status":1, "message":"装備品の情報更新完了"});

        this.TotalOperatingTime = this.newTotalOperatingTime
        this.TotalOperatingTimeUnit = this.newTotalOperatingTimeUnit
        this.TotalOperatingTimeUnitText = this.newTotalOperatingTimeUnitText 

        this.SinceOverhaulTime = this.newSinceOverhaulTime
        this.SinceOverhaulTimeUnit = this.newSinceOverhaulTimeUnit
        this.SinceOverhaulTimeUnitText = this.newSinceOverhaulTimeUnitText

        this.usageTime = 0

        this.newTotalOperatingTime = null
        this.newTotalOperatingTimeUnit = ""
        this.newTotalOperatingTimeUnitText = ""

        this.newSinceOverhaulTime = null
        this.newSinceOverhaulTimeUnit = ""
        this.newSinceOverhaulTimeUnitText = ""

//        this.isUsageTimeUpdate = false

        this.$refs.isLoading.end();

        this.successUsageTimeUpdate = true

        this.isPageMove=true
      } catch (error) {
        console.log('updateUsageTime error: ', error)
        this.isPageMove=true
        this.processing = false
        this.$refs.isLoading.end();
        this.$refs.isFailured.open();
      }
    
    },
    getMachine: async function () {
      let machine = await API.graphql(graphqlOperation(getMachine, {id: this.machineid}))

      this.Name = machine.data.getMachine.Name
      this.CustomerMachineID = machine.data.getMachine.CustomerMachineID
      this.MakerID = machine.data.getMachine.MakerID
      this.MakerText = machine.data.getMachine.MakerID
      this.ModelNumber = machine.data.getMachine.ModelNumber
      this.PurchasedDate = machine.data.getMachine.PurchasedDate
      this.MachineMemo = machine.data.getMachine.MachineMemo
      this.TotalOperatingTime = machine.data.getMachine.TotalOperatingTime
      this.TotalOperatingTimeUnit = machine.data.getMachine.TotalOperatingTimeUnit
      this.TotalOperatingTimeUnitText = machine.data.getMachine.TotalOperatingTimeUnitText

      this.OverhaulDate = machine.data.getMachine.OverhaulDate
      this.SinceOverhaulTime = machine.data.getMachine.SinceOverhaulTime
      this.SinceOverhaulTimeUnit = machine.data.getMachine.SinceOverhaulTimeUnit
      this.SinceOverhaulTimeUnitText = machine.data.getMachine.SinceOverhaulTimeUnitText

      // 航空機の場合、使用時間系の単位はHr固定
      if(this.AnalizeTypeCategory == "航空機") {
        this.TotalOperatingTimeUnit = "10000002"
        this.TotalOperatingTimeUnitText = ""

        this.SinceOverhaulTimeUnit = "10000002"
        this.SinceOverhaulTimeUnitText = ""
      }

      let mountedMachines = await API.graphql(graphqlOperation(mountedMachine, {MountedMachineID: this.machineid}))
      console.log("mountedMachines", mountedMachines)
      this.mountedMachines = mountedMachines.data.mountedMachine.items

    },
    changeStepper: function(step) {
      this.e6 = this.validation(step)
    },
    validation: function (step) {
      if(step >= 2) {
        this.$v.Name.$touch()
        this.$v.CustomerMachineID.$touch()
        this.$v.MakerID.$touch()
        this.$v.PurchasedDate.$touch()
        this.$v.TotalOperatingTime.$touch()
        this.$v.OverhaulDate.$touch()
        this.$v.SinceOverhaulTime.$touch()
        if (this.$v.Name.$invalid ||
            this.$v.CustomerMachineID.$invalid ||
            this.$v.MakerID.$invalid ||
            this.$v.PurchasedDate.$invalid ||
            this.$v.TotalOperatingTime.$invalid ||
            this.$v.OverhaulDate.$invalid ||
            this.$v.SinceOverhaulTime.$invalid
        ) {
          console.log('error: ', 'validation error Page1')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          this.e6 = 1
          return this.e6
        }
      }
      if(step >= 3) {
        this.isConfirmed=true
      }
      return step
    },
    createMachine: async function () {
      this.isConfirmed = false
      this.processing = true

      let valid = this.validation(3)
      if(valid != 3) {
        return
      }

      // fload型の要素はnullに変換
      if(this.TotalOperatingTime == "") this.TotalOperatingTime = null
      if(this.SinceOverhaulTime == "") this.SinceOverhaulTime = null

      let _PurchasedDate = ""
      if(this.PurchasedDate == null) {
        this.PurchasedDate = ""
      }
      if(this.PurchasedDate != "") {
        let _date = new Date(this.PurchasedDate)
        let format_str = 'YYYY-MM-DD';
        format_str = format_str.replace(/YYYY/g, _date.getFullYear());
        format_str = format_str.replace(/MM/g, ('0' + (_date.getMonth() + 1)).slice(-2));
        format_str = format_str.replace(/DD/g, ('0' + _date.getDate()).slice(-2));
        _PurchasedDate = format_str
        console.log(this.PurchasedDate, _PurchasedDate)
      }

      let _OverhaulDate = ""
      if(this.OverhaulDate == null) {
        this.OverhaulDate = ""
      }
      if(this.OverhaulDate != "") {
        let _date = new Date(this.OverhaulDate)
        let format_str = 'YYYY-MM-DD';
        format_str = format_str.replace(/YYYY/g, _date.getFullYear());
        format_str = format_str.replace(/MM/g, ('0' + (_date.getMonth() + 1)).slice(-2));
        format_str = format_str.replace(/DD/g, ('0' + _date.getDate()).slice(-2));
        _OverhaulDate = format_str
        console.log(this.OverhaulDate, _OverhaulDate)
      }

      const machine = {
        Name: this.Name,
        Type: this.Type,
        MachineCategory: "",
        MachineCategoryText: "",
        MachineType: "",
        MachineTypeText: "",
        CustomerName: this.CustomerName,
        CustomerMachineID: this.CustomerMachineID,
        Equipment: this.Equipment,
        MakerID: this.MakerID,
        MakerText: this.MakerID,
        ModelNumber: this.ModelNumber,
        PurchasedDate: _PurchasedDate, // YYYY/MM/DD形式に変換した値
        MachineMemo: this.MachineMemo,
        TotalOperatingTime: this.TotalOperatingTime,
        TotalOperatingTimeUnit: this.TotalOperatingTimeUnit,
        TotalOperatingTimeUnitText: this.TotalOperatingTimeUnitText,
        OverhaulDate: _OverhaulDate, // YYYY/MM/DD形式に変換した値
        SinceOverhaulTime: this.SinceOverhaulTime,
        SinceOverhaulTimeUnit: this.SinceOverhaulTimeUnit,
        SinceOverhaulTimeUnitText: this.SinceOverhaulTimeUnitText,
        AnalizeType: this.AnalizeType,
        OfficeID: this.$store.state.operatingOffice.OfficeID,
      }
      
      try {
        if(this.isCreate) {
          let result = await API.graphql(graphqlOperation(createMachine, {input: machine}))
          // console.log('success', machine)
          console.log('success', result)
          this.successText = '新しいマイ機器を登録しました。<br><br>ご登録いただいた機器は、マイ機器よりご確認ください。',
          window.removeEventListener("beforeunload", this.handler)
          this.isPageMove=true
          this.machineid = result.data.createMachine.id
          this.isConfirmed = false
          this.successCreateMachine = true
//          this.$refs.isMSuccessed.open(result);
          // this.isSuccessed = true
          // this.$router.push('/mymachinelist')
        }else {
          machine["id"] = this.machineid
          await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "Update"
          machineLog.Detail = JSON.stringify(machine)

          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

          // console.log('success', machine)
          this.successText = 'マイ機器情報を更新しました。<br><br>更新した内容は、マイ機器一覧よりご確認ください。',
          window.removeEventListener("beforeunload", this.handler)
          this.isPageMove=true
          this.$refs.isSuccessed.open();
        }
      } catch (error) {
        console.log('error: ', error)
        this.processing = false
        this.$refs.isFailured.open();
      }
    },
    deleteMachine: async function () {
      const deleteinfo = {
        id: this.machineid,
      }
      try {
        await API.graphql(graphqlOperation(deleteMachine, {input: deleteinfo}))
        console.log('success', "delete")
        window.removeEventListener("beforeunload", this.handler)
        this.isPageMove=true
        this.$router.push('/mymachinelist')
      } catch (error) {
        console.log('error: ', error)
      }
    },
    showDeleteMachine() {
      this.$refs.deletedialog.open();
    },
    changeOperatingTimeUnit: async function () {
      if(this.OperatingTimeUnit) {
        const OperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.OperatingTimeUnit)
        this.OperatingTimeUnitText = OperatingTimeUnitNames[0].Text
      }else {
          this.OperatingTimeUnit = null
          this.OperatingTimeUnitText = ""
      }
    },
    changeTotalOperatingTimeUnit: async function () {
      if(this.TotalOperatingTimeUnit) {
        const TotalOperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.TotalOperatingTimeUnit)
        this.TotalOperatingTimeUnitText = TotalOperatingTimeUnitNames[0].Text
      }else {
        this.TotalOperatingTimeUnit = ""
        this.TotalOperatingTimeUnitText = ""
      }
    },
    changeNewTotalOperatingTimeUnit: async function () {
      if(this.newTotalOperatingTimeUnit) {
        const TotalOperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.newTotalOperatingTimeUnit)
        this.newTotalOperatingTimeUnitText = TotalOperatingTimeUnitNames[0].Text
      }else {
        this.newTotalOperatingTimeUnit = ""
        this.newTotalOperatingTimeUnitText = ""
      }
    },

    changeSinceOverhaulTimeUnit: async function () {
      if(this.SinceOverhaulTimeUnit) {
        const SinceOverhaulTimeUnitNames = this.useUnits.filter(item => item.Value == this.SinceOverhaulTimeUnit)
        this.SinceOverhaulTimeUnitText = SinceOverhaulTimeUnitNames[0].Text
      }else {
        this.SinceOverhaulTimeUnit = ""
        this.SinceOverhaulTimeUnitText = ""
      }
    },

    changeNewSinceOverhaulTimeUnit: async function () {
      if(this.newSinceOverhaulTimeUnit) {
        const SinceOverhaulTimeUnitNames = this.useUnits.filter(item => item.Value == this.newSinceOverhaulTimeUnit)
        this.newSinceOverhaulTimeUnitText = SinceOverhaulTimeUnitNames[0].Text
      }else {
        this.newSinceOverhaulTimeUnit = ""
        this.newSinceOverhaulTimeUnitText = ""
      }
    },    

    changeSyncUsageTime: async function() {
      if(this.syncUsageTime) {
        this.calcUsageTime()
      }else {
        this.newTotalOperatingTime = this.TotalOperatingTime
        this.newSinceOverhaulTime = this.SinceOverhaulTime
        this.syncMountedMachine = false
      }
    },
    calcUsageTime: async function() {
      this.$v.usageTime.$touch()
      if (!this.$v.usageTime.$invalid) {
        if(this.syncUsageTime) {
          this.newTotalOperatingTime = this.calcTime(this.TotalOperatingTime, this.usageTime)

          // オーバーホールしていない＝オーバーホール日が設定されていない場合は更新しない
          if(this.OverhaulDate) {
            this.newSinceOverhaulTime = this.calcTime(this.SinceOverhaulTime, this.usageTime)
          }
        }
      }
    },

    selectMachine: async function(selectedMachine) {
      console.log("selectMachine", selectedMachine)
      console.log("this.selectedMachines", this.selectedMachines)
      if(selectedMachine.Type == "機体") {
          this.$router.push("myaircraft?id=" + selectedMachine.id)
      }else {
        this.$router.push("/mymachine?id=" + selectedMachine.id)
      }
    },
    selectAllMachines: async function(event) {
      var toggle = event.value;
      console.log("selectAllMachines", toggle)
    },
    openWindow (url) {
      window.open(url, '_blank')
    },
    handler (event) {
      event.returnValue = "Data you've inputted won't be synced"
      console.log('ページ離脱')
    },
    toUpdateMachine: async function() {
      this.isConfirmed = false
      this.successCreateMachine = false
      this.processing = false
      this.isCreate = false
      this.isDetailInput = false
      this.initialize()
      this.moveToTop()
    },
    initialize: async function() {
      if(this.machineid) {
        await this.getMachine()
      }
    }
  },
  mounted: async function () {
    console.log('machine id: ', this.$route.query.id)
    if (this.$route.query.id == undefined){
      this.isCreate = true
      this.isDetailInput = true
      this.Type = this.$route.query.type //機体／装備装置
      this.AnalizeTypeCategory = this.$route.query.category
      switch(this.AnalizeTypeCategory) {
        case "一般":
          this.AnalizeType = "1000"
          break
        case "航空機":
          this.AnalizeType = "2000"
          break
        default:
          this.AnalizeType = "3000"
          break
      }
      console.log('isCreate: ', this.isCreate)
      this.overlayStepper1 = false
    }else {
      this.isCreate = false
      this.isDetailInput = false
      this.machineid = this.$route.query.id

      let machine = await API.graphql(graphqlOperation(getMachine, {id: this.machineid}))

      // マイ機器情報のアクセスチェック
      // 存在しないマイ機器、他事業所のマイ機器を開いた場合はアクセス不正でエラーにする
      if(!machine.data.getMachine) {
        this.isErrorParam = true
        this.ErrorInfo = "notExist"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }
      if(machine.data.getMachine.OfficeID != this.$store.state.operatingOffice.OfficeID) {
        this.isErrorParam = true
        this.ErrorInfo = "illegalAccess"
        this.overlayStepper1 = false
        console.log('isErrorParam: ', this.isErrorParam)
        return
      }

      if(machine.data.getMachine.AnalizeType) {
        let category = machine.data.getMachine.AnalizeType.substring(0, 1)
        console.log("category", category)
        switch(category) {
          case "1":
            this.AnalizeTypeCategory = "一般"
            break
          case "2":
            this.AnalizeTypeCategory = "航空機"
            break
          default:
            this.AnalizeTypeCategory = "JXTG"
            break
        }
      }else {
          this.AnalizeTypeCategory = "一般"
      }
      console.log("AnalizeTypeCategory", this.AnalizeTypeCategory)

      let type = machine.data.getMachine.Type
      if(type == undefined) {
        this.Type = "装備装置"
      }else {
        this.Type = type
      }
    }

    this.initialize()

    // 航空機の場合、使用時間系の単位はHr固定
    if(this.AnalizeTypeCategory == "航空機") {
      this.TotalOperatingTimeUnit = "10000002"
      this.TotalOperatingTimeUnitText = ""
      this.SinceOverhaulTimeUnit = "10000002"
      this.SinceOverhaulTimeUnitText = ""

    }

    this.overlayStepper1 = false
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
  }
</script>